module.exports = __webpack_public_path__ + "assets/img/bottom-bg.ffe03168.png";